export const userTypes = {
  STANDARD: "standard",
  STAFF: "staff",
  EMPLOYER: "employer",
};
